module.exports = __webpack_public_path__ + "img/terceirizado.8160048f.png";